import styled, { css } from 'styled-components';
import {
  mq,
  getSpace,
  getGridSpan,
  getGridSpans,
  getTextType,
  borderShape,
  px2rem
} from '../../../stylesheets/tools';

const StyledDownload = styled.a`
  position: relative;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 0 0 ${getSpace('s')};
  color: black;
  text-decoration: none;

  ${props => (!props.vertical && props.borderless ? null : borderShape())}

  .download__image {
    padding: ${getSpace('xs')} 0 ${getSpace('xs')} ${getSpace('xs')};

    img {
      height: auto;
      width: 95px;
    }
  }

  .download__content {
    flex-grow: 2;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: ${getSpace('xs')};

    p {
      width: 100%;
    }
  }

  .download__headline {
    text-transform: uppercase;
    margin: 0;
  }
  
  .download__description {
    ${getTextType('copySmall', 'international')}
    margin: 10px 0 0;
  }

  .download__icon {
    ${getTextType('copySmall', 'international')}
    width: 100%;
    min-width: ${px2rem('110px')};
    border: 2px solid #000;
    color: #000;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
    background: ${props => (props.theme.siteTheme ? props.theme.siteTheme.primary : '')};


    svg {
      display: block;
    }

    span {
      margin-top: 10px;
      display: inline-block;
      text-align: center;
      text-transform: uppercase;
    }
  }
  
  .download__date {
    width: ${px2rem('100px')};
    min-width: ${px2rem('100px')};
    position: relative;
    padding: ${getSpace('xs')} ${getSpace('xxs')};
    text-align: right;
    display: flex;
    flex-direction:column;
    align-items: flex-end;
    justify-content: center;

    span {
      display: block;
      ${getTextType('tertiary')};
      font-size: 1.25rem;
      line-height: 1.5rem;
      text-transform: uppercase;
    }

    &:before {
      position: absolute;
      content: '';
      width: 2px;
      height: 40px;
      right: -2px;
      background: black;
      top: -10px;
    }

    &:after {
      display: none;
      position: absolute;
      content: '';
      width: 2px;
      height: 10px;
      right: -2px;
      background: black;
      bottom: -10px;
    }
  }

  &:hover, &:focus {
    .download__icon {
      background: black;
      color: white;
    }
  }

  ${props =>
    !props.vertical &&
    css`
      ${getGridSpans('width', { m: 10, l: 9, xl: 8 })}

      ${mq('m')} {
        flex-wrap: nowrap;
        align-items: stretch;
        flex-direction: row;
        justify-content: center;
        margin: ${getSpace('l')} ${getGridSpan('2', 'spread')} ${getSpace('l')} 0;

        &:nth-of-type(even) {
          margin: ${getSpace('l')} 0 ${getSpace('l')} ${getGridSpan('2', 'spread')};
        }

        .download__icon {
          width: ${px2rem('110px')};
          border-left: 2px solid black;
        }

        .download__date {
          border-right: 2px solid black;

          &:before {
            height: 10px;
          }

          &:after {
            display: block;
          }
        }
      }

      ${props.borderless &&
        css`
          border-top: 2px solid #000;
          ${getGridSpans('margin-left', {
            m: ['1', 'spread'],
            l: ['1.5', 'spread'],
            xl: ['2', 'spread']
          })}

          .download__icon {
            border: none;
            background: transparent;
          }

          &:hover,
          &:focus {
            .download__icon {
              background: transparent;
              color: #000;
            }
          }
        `}
    `}
 
  /* Vertical Downloadlink */
  ${props =>
    props.vertical &&
    css`
      width: 100%;
      ${getGridSpans('width', { m: 5, l: 4, xl: 3 })}
      float: left;

      &:nth-of-type(even) {
        margin: 0 30px ${getSpace('s')} 0;
      }

      ${mq('m')} {
        margin: 0 30px ${getSpace('s')} 0;
      }

      .download__headline {
        padding: ${getSpace('xs')};
      }

      .download__description {
        padding: ${getSpace('xs')};
      }
    `}

  ${props =>
    props.vertical &&
    props.hasDate &&
    css`
      .download__date {
        width: ${getSpace('95px')};
        min-width: ${getSpace('95px')};
        text-align: left;
      }
      .download__headline {
        width: calc(100% - 100px);
      }
    `}

  ${props =>
    props.vertical &&
    props.hasDate &&
    props.hasImage &&
    css`
      .download__headline {
        width: 100%;
        padding: ${getSpace('xs')} ${getSpace('xs')} 0;
      }

      .download__description {
        padding: 0 ${getSpace('xs')} ${getSpace('xs')};
      }

      .download__image {
        width: calc(100% - ${getSpace('95px')});
        padding: ${getSpace('xs')};
        display: flex;
        justify-content: flex-end;
      }
    `}

  ${props =>
    props.vertical &&
    !props.hasDate &&
    props.hasImage &&
    css`
      .download__headline {
        width: calc(100% - 120px);
      }

      .download__image {
        width: 120px;
        height: auto;
        padding-right: 0;

        img {
          width: 100%;
          height: auto;
        }
      }
    `}


    // Content blocks override to prevent overlapping with aside
    .contentBlocks__container & {
      width: auto;
      margin-left: ${getGridSpan('1', 'spread')};

      ${mq('m')} {
        margin-left: ${getGridSpan('2', 'spread')} !important;
        margin-right: ${getGridSpan('1', 'spread')};
      }
    }

  @media print {
    display: none;
  }
`;

export default StyledDownload;
